import { render, staticRenderFns } from "./LanguagesAddModal.vue?vue&type=template&id=c7a414f2"
import script from "./LanguagesAddModal.vue?vue&type=script&lang=ts"
export * from "./LanguagesAddModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7a414f2')) {
      api.createRecord('c7a414f2', component.options)
    } else {
      api.reload('c7a414f2', component.options)
    }
    module.hot.accept("./LanguagesAddModal.vue?vue&type=template&id=c7a414f2", function () {
      api.rerender('c7a414f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/LanguagesAddModal.vue"
export default component.exports